import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    
}

export const profileSlice = createSlice({
    name: 'profile',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            state = {
                ...state, 
                ...payload.payload
            };
            return state;
        }
    },
})

export const { edit } = profileSlice.actions

export default profileSlice.reducer